import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Select,
  MenuItem,
  TextField,
  TablePagination
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useUpdate, useDelete } from "../../hooks";
// Import local images

const statusColors = {
  High: "red",
  Medium: "orange",
  Low: "green",
};

export default function AdminComplaints() {
  const [viewDialog, setViewDialog] = useState(false);
  const [search, setSearch] = useState("");
  const [data, setData] = useState("");
  const [selectedComplaint, setSelectedComplaint] = useState(null);
  const [status, setStatus] = useState("Pending");
  const [reason, setReason] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [previewImage, setPreviewImage] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    message: "",
    status: "",
  });
  const loginToken = useSelector((state) => state.user.logintoken);
  
  //get All Admin vendor complaints
  useEffect(() => {
    fetchData();
  }, []);

  //get All Complaints data
  const {
    data: complaintsData,
    isLoading: isComplaintsLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllAdminVendorComplaints"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
    const {
      data: updateComplaintsData,
      isLoading: updateComplaintsLoading,
      error: updateComplaintsError,
      updateData: fetchUpdateData,
    } = useUpdate(BASE_URL_TEST, {
      method: "PUT",
      headers: {
        Authorization: loginToken ? `Bearer ${loginToken}` : "",
      },
    });
  useEffect(() => {
    if (error) {
    } else if (complaintsData && complaintsData["status"] === true) {
      setData(complaintsData["data"] || []);
    }
  }, [complaintsData, error]);

   //Update Admin Complaints
    useEffect(() => {
      if (updateComplaintsError) {
      } else if (updateComplaintsData && updateComplaintsData["status"] === true) {
        setSnackbarState({
          ...snackbarState,
          message: updateComplaintsData["message"],
          status: updateComplaintsData["status"],
        });
        setModalOpen(true);
        fetchData();
      } else if (updateComplaintsData && updateComplaintsData["status"] === false) {
        setSnackbarState({
          ...snackbarState,
          message: updateComplaintsData["message"],
          status: updateComplaintsData["status"],
        });
        setModalOpen(true);
        fetchData();
      }
    }, [updateComplaintsData, updateComplaintsError]);
  

  const handleView = (complaint) => {
    setForm(complaint);
    setSelectedComplaint(complaint);
    setStatus("Pending");
    setReason(complaint.reason);
    setViewDialog(true);
  };

  const handleUpdate = (complaint) => {
    console.log("Updated Status:", status);
    console.log("Updated Reason:", reason);
    setViewDialog(false);
    const formdata = new FormData();
    formdata.append("name", complaint["name"] ? complaint["name"] : "");
    formdata.append(
      "description",
      complaint["description"] ? complaint["description"] : ""
    );
    formdata.append("complaint_status", status ? status : "");
    formdata.append("reason", reason ? reason : "");
    formdata.append("vendor_id", complaint.vendor_id);

    const updateUrl = urls("updateAdminComplaints", complaint["complaint_id"]);

    fetchUpdateData(updateUrl, formdata);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  // Handle search
  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  // Handle Image Preview Click
  const handleImageClick = (imageUrl) => {
    setPreviewImage(imageUrl); // Set clicked image as preview
  };

  const [form, setForm] = useState({
    vendorId: "",
    productId: "",
    category: "",
    subcategory: "",
    title: "",
    salesPrice: "",
    status: "Active",
    description: "",
    image: "",
  });

  // Filter data based on search
  const filteredData =
    Array.isArray(data) && data.length > 0 // Check if data is an array
      ? data
          .sort((a, b) => b.complaint_id - a.complaint_id) // Sort by ID in descending order
          .filter(
            (item) =>
              (item.complaint_id &&
                item.complaint_id
                  .toString()
                  .toLowerCase()
                  .includes(search.toLowerCase())) ||
              (item.vendor_id &&
                item.vendor_id
                  .toString()
                  .toLowerCase()
                  .includes(search.toLowerCase())) ||
              (item.name &&
                item.name.toLowerCase().includes(search.toLowerCase()))
          )
      : []; 

      const handleClose = () => {
        setModalOpen(false);
          if (updateComplaintsData && updateComplaintsData["status"] === true) {
            setViewDialog(false);
          }
        }

  return (
    <Box sx={{ bgcolor: "white", p: 2 }}>
      <TextField
        variant="outlined"
        placeholder="Search"
        size="small"
        value={search}
        onChange={handleSearch}
        sx={{
          width: "30%",
          backgroundColor: "#FFF",
          borderRadius: 1,
        }}
      />
      <TableContainer component={Paper} sx={{ borderRadius: "20px", mt: 2 }}>
        <Table sx={{ minWidth: 650 }} aria-label="complaints table">
          <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Complaint ID</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Vendor ID</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Complaint Name</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Description</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Image</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Priority</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <Typography>No records found</Typography>
                </TableCell>
              </TableRow>
            ) : (
              filteredData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((complaint) => {
                  return (
                    <TableRow key={complaint.complaint_id}>
                      <TableCell>{complaint.complaint_id}</TableCell>
                      <TableCell>{complaint.vendor_id}</TableCell>
                      <TableCell>{complaint.name}</TableCell>
                      <TableCell>{complaint.description}</TableCell>
                      <TableCell>
                        {complaint.images && complaint.images.length > 0
                          ? complaint.images.map((image, index) => (
                              <img
                                key={image.complaint_image_id}
                                src={image.image_url}
                                alt={`image-${index}`}
                                width={40}
                                height={40}
                                style={{ marginRight: "5px" }}
                              />
                            ))
                          : "No Image"}
                      </TableCell>

                      <TableCell
                        sx={{
                          color: statusColors[complaint.complaint_status],
                          fontWeight: "bold",
                        }}
                      >
                        {complaint.complaint_status}
                      </TableCell>
                      <TableCell>
                        {" "}
                        {complaint.status == 1
                          ? "Active"
                          : complaint.status == 0
                          ? "Inactive"
                          : ""}
                      </TableCell>
                      <TableCell>
                        <IconButton onClick={() => handleView(complaint)}>
                          <VisibilityIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 15]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>

      {/* Image Preview Modal */}
      <Dialog
        open={previewImage !== null}
        onClose={() => setPreviewImage(null)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Image Preview
          <IconButton
            aria-label="close"
            onClick={() => setPreviewImage(null)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ textAlign: "center" }}>
            <img
              src={previewImage}
              alt="Preview"
              style={{
                width: "100%",
                maxWidth: "600px",
                objectFit: "contain",
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPreviewImage(null)} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Complaint View Dialog */}
      <Dialog
        open={viewDialog}
        onClose={() => setViewDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Complaint Details
          <IconButton
            aria-label="close"
            onClick={() => setViewDialog(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {selectedComplaint && (
            <TableContainer>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Complaint Name
                    </TableCell>
                    <TableCell>{selectedComplaint.name}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Description
                    </TableCell>
                    <TableCell>{selectedComplaint.description}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Image</TableCell>
                    <TableCell>
                      {selectedComplaint.images &&
                      selectedComplaint.images.length > 0
                        ? selectedComplaint.images.map((image, index) => (
                            <img
                              key={image.complaint_image_id}
                              src={image.image_url}
                              alt={`preview-${index}`}
                              width={100}
                              height={100}
                              style={{
                                borderRadius: "8px",
                                marginRight: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() => handleImageClick(image.image_url)}
                            />
                          ))
                        : "No Image"}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                    <TableCell>
                      <Select
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        fullWidth
                      >
                        <MenuItem value="Pending">Pending</MenuItem>
                        <MenuItem value="Completed">Completed</MenuItem>
                      </Select>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Reason</TableCell>
                    <TableCell>
                      <TextField
                        fullWidth
                        multiline
                        rows={4}
                        label="Reason"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleUpdate(selectedComplaint)} variant="contained" color="primary">
            Update
          </Button>
        </DialogActions>
      </Dialog>
        <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
              <DialogTitle>
                {snackbarState.status === true ? "Success" : "Error"}
              </DialogTitle>
              <DialogContent>
                <Typography
                  variant="body1"
                  sx={{
                    color: snackbarState.status === true ? "green" : "red",
                  }}
                >
                  {snackbarState.message}
                </Typography>
              </DialogContent>
              <DialogActions
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleClose}
                  sx={{
                    textTransform: "none",
                    borderRadius: 2,
                    alignSelf: "center",
                  }}
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
    </Box>
  );
}
